import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs/operators';
import {catchError, of, switchMap} from 'rxjs';
import {UserService} from '../../../shared/services/user.service';

export const authGuard: CanActivateFn = (route, state) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const userService = inject(UserService);
  const router = inject(Router);

  return oidcSecurityService.checkAuth().pipe(
    switchMap(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        void router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return of(false);
      }

      return userService.loadUserProfile().pipe(
        map(() => true),
        catchError(() => {
          void router.navigate(['/auth']);
          return of(false);
        })
      );
    })
  );
};
